var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c("pulse-loader", {
          staticStyle: { "text-align": "center" },
          attrs: { loading: _vm.loading, color: _vm.color },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Проект")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.letter.site_id,
                expression: "letter.site_id",
              },
            ],
            staticClass: "form-control",
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.letter,
                    "site_id",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
                _vm.loadLetter,
              ],
            },
          },
          [
            _c("option", { attrs: { value: "0" } }, [_vm._v("Мастер шаблон")]),
            _vm._v(" "),
            _vm._l(_vm.projects, function (name, index) {
              return _c("option", { key: index, domProps: { value: index } }, [
                _vm._v(_vm._s(name)),
              ])
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Тип письма")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.letter.type,
                expression: "letter.type",
              },
            ],
            staticClass: "form-control",
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.letter,
                    "type",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
                _vm.loadLetter,
              ],
            },
          },
          _vm._l(_vm.types, function (type, index) {
            return _c("option", { key: index, domProps: { value: index } }, [
              _vm._v(_vm._s(type)),
            ])
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Отправитель")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.letter.sender_account_id,
                expression: "letter.sender_account_id",
              },
            ],
            staticClass: "form-control",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.letter,
                  "sender_account_id",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          _vm._l(_vm.senderAccounts, function (a) {
            return _c("option", { domProps: { value: a.id } }, [
              _vm._v(_vm._s(a.title) + " (" + _vm._s(a.login) + ")"),
            ])
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Тема письма")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|min:10|max:1000",
              expression: "'required|min:10|max:1000'",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.letter.subject,
              expression: "letter.subject",
            },
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "subject",
            "data-vv-as": "Тема письма",
            placeholder: "Ваш заказ...",
          },
          domProps: { value: _vm.letter.subject },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.letter, "subject", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.errors.has("subject")
          ? _c("small", { staticClass: "form-text text-danger" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.errors.first("subject")) + "\n      "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-8" },
      [
        _vm.letter
          ? [
              _c(
                "div",
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Фиксированный блок"),
                  ]),
                  _vm._v(" "),
                  _c("ckeditor", {
                    attrs: { editor: _vm.editor, config: _vm.editorConfig },
                    model: {
                      value: _vm.letter.fixed_block,
                      callback: function ($$v) {
                        _vm.$set(_vm.letter, "fixed_block", $$v)
                      },
                      expression: "letter.fixed_block",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Текст письма")]),
                  _vm._v(" "),
                  _c("ckeditor", {
                    attrs: { editor: _vm.editor, config: _vm.editorConfig },
                    model: {
                      value: _vm.letter.body,
                      callback: function ($$v) {
                        _vm.$set(_vm.letter, "body", $$v)
                      },
                      expression: "letter.body",
                    },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-12 text-right" },
      [
        _c(
          "vue-ladda",
          {
            attrs: {
              "button-class": "btn btn-success",
              "data-style": "zoom-in",
              loading: _vm.submit_form_loading,
            },
            on: { click: _vm.updateLetter },
          },
          [_vm._v("Сохранить\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-4" }, [
      _c("p", [
        _c("strong", [_vm._v("${fixedBlock}")]),
        _vm._v(
          " - фиксированный блок, который не доступен к редактированию при отправки"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_c("strong", [_vm._v("${preps}")]), _vm._v(" - препарат(ы)")]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${orderNo}")]),
        _vm._v(" - номер заявки"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${site_source}")]),
        _vm._v(" - сайт, где был создан заказ"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${preps_qnty_prices}")]),
        _vm._v(" - перпарат количество - сумма"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${total_price}")]),
        _vm._v(" - cумма заяки + доставка - скидка"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${preps_price}")]),
        _vm._v(" - cумма заяки (стоимость всех препаратов)"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${delivery_price}")]),
        _vm._v(" - стоимость доставки"),
      ]),
      _vm._v(" "),
      _c("p", [_c("strong", [_vm._v("${name}")]), _vm._v(" - имя клиента")]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${card}")]),
        _vm._v(" - карта получателя"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${cardHolder}")]),
        _vm._v(" - имя получателя"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("${postTrackNum}")]),
        _vm._v(" - почтовы трек номер"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }